import React, { Component } from "react";
import axios from "axios";
import Session from "./Session";
import domain from ".././../../../domain";

class Sessions extends Component {
  constructor() {
    super();
    this.state = {
      sessions: [],
    };
  }

  componentDidMount() {
    this.getSessions();
  }

  getSessions() {
    axios
      .get(`${domain.DBServer}/fetch-sessions`)
      .then((response) => {
        console.log(response.data);
        this.setState({ sessions: response.data }, () => {
          //console.log(this.state);
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    const sessions = this.state.sessions.map((session, i) => {
      return <Session key={session.id} data={session} />;
    });

    return (
      <div>
        <h1>Session Wise Details</h1>
        <ul className="collection">{sessions}</ul>
      </div>
    );
  }
}

export default Sessions;
